import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./styles.scss";

const CheckboxWithLabel = ({
  label,
  disabled,
  readonly,
  className,
  classes,
  ...props
}) => (
  <label
    className={classNames(
      "mydpd-ckeckbox-label-container",
      className,
      readonly && "readonly",
      disabled && "disabled"
    )}
  >
    <input type="checkbox" {...props} disabled={disabled || readonly} />
    <span
      className={classNames("mydpd-ckeckbox-label", classes && classes.label)}
    >
      {label}
    </span>
    <span
      className={classNames(
        "mydpd-ckeckbox-checkmark",
        classes && classes.checkmark
      )}
    ></span>
  </label>
);

CheckboxWithLabel.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
};

export default CheckboxWithLabel;
